import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getAuthToken, parseJwt } from "@client/api/client";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: () => {
    const token = getAuthToken();
    if (!token) throw redirect({ to: "/auth" });
    const user = parseJwt(token);
    if (!user || user.exp * 1000 < Date.now()) {
      throw redirect({ to: "/auth" });
    }
    return { user };
  },
  component: () => <Outlet />,
});
